import { Routes } from '@angular/router';
import { CoursesHubComponent } from './views/courses-hub/courses-hub.component';
import { cssJsResolver } from './guards/what-degree-can-i-do-with-my-alevels.resolver';
import { ClearingCourseSearchComponent } from './views/clearing-course-search/clearing-course-search.component';
import { CourseDegreeHubComponent } from './views/course-degree-hub/course-degree-hub.component';
import {
	ACCESS_TO_HIGHER_EDUCATION_DATA,
	CLEARING_DATA,
	DEGREES_DATA,
	FOUNDATION_DATA,
	HNC_DATA,
	HND_DATA,
	MASTERS_DATA,
	PGCE_DATA,
	PHD_DATA,
	POSTGRADUATE_CERTIFICATE_DATA,
	POSTGRADUATE_CERTIFICATE_DIPLOMAS_DATA,
	POSTGRADUATE_DATA,
	POSTGRADUATE_DIPLOMA_DATA,
	UNDERGRADUATE_CERTIFICATE_DIPLOMAS_DATA,
	UNDERGRADUATE_DATA,
} from './static/course-degree-hub.properties';
import { CourseSearchComponent } from './views/course-search/course-search.component';
import { validateLocationGuard } from './guards/validate-location.guard';
import { validateSubjectGuard } from './guards/validate-subject.guard';
import { validateDegreeAndLocationGuard } from './guards/validate-degree-and-location.guard';
import { validateDegreeGuard } from './guards/validate-degree.guard';
import { initialiseScrollerGuard } from './guards/initialise-scroller.guard';
import { resetScrollerGuard } from './guards/reset-scroller.guard';
import { UniversityCourseSearchComponent } from './views/university-course-search/university-course-search.component';
import { validateUniSlugGuard } from './guards/validate-uni-slug.guard';

export const COURSES_ROUTES: Routes = [
	// HUB ROUTES
	{ path: '', component: CoursesHubComponent },
	{
		path: 'what-degree-can-i-do-with-my-a-levels',
		loadComponent: () =>
			import('@uc/web/outsourced/pages/what-degree-can-i-do-with-my-alevels').then(
				(c) => c.WhatDegreeCanIDoWithMyAlevelsComponent,
			),
		resolve: { cssLoaded: cssJsResolver },
	},
	{
		path: 'degrees/undergraduate',
		component: CourseDegreeHubComponent,
		data: {
			data: { ...UNDERGRADUATE_DATA },
		},
	},
	{
		path: 'degrees/undergraduate-certificate-diplomas',
		component: CourseDegreeHubComponent,
		data: { data: { ...UNDERGRADUATE_CERTIFICATE_DIPLOMAS_DATA } },
	},
	{
		path: 'degrees/postgraduate',
		component: CourseDegreeHubComponent,
		data: { data: { ...POSTGRADUATE_DATA } },
	},
	{
		path: 'degrees/postgraduate-certificate-diplomas',
		component: CourseDegreeHubComponent,
		data: { data: { ...POSTGRADUATE_CERTIFICATE_DIPLOMAS_DATA } },
	},
	{
		path: 'degrees/hnd',
		component: CourseDegreeHubComponent,
		data: { data: { ...HND_DATA } },
	},
	{
		path: 'degrees/hnc',
		component: CourseDegreeHubComponent,
		data: { data: { ...HNC_DATA } },
	},
	{
		path: 'degrees/masters',
		component: CourseDegreeHubComponent,
		data: { data: { ...MASTERS_DATA } },
	},
	{
		path: 'degrees/pgce',
		component: CourseDegreeHubComponent,
		data: { data: { ...PGCE_DATA } },
	},
	{
		path: 'degrees/phd',
		component: CourseDegreeHubComponent,
		data: { data: { ...PHD_DATA } },
	},
	{
		path: 'degrees/postgraduate-diploma',
		component: CourseDegreeHubComponent,
		data: { data: { ...POSTGRADUATE_DIPLOMA_DATA } },
	},
	{
		path: 'degrees/postgraduate-certificate',
		component: CourseDegreeHubComponent,
		data: { data: { ...POSTGRADUATE_CERTIFICATE_DATA } },
	},
	{
		path: 'degrees/access-to-higher-education',
		component: CourseDegreeHubComponent,
		data: { data: { ...ACCESS_TO_HIGHER_EDUCATION_DATA } },
	},
	{
		path: 'degrees/foundation',
		component: CourseDegreeHubComponent,
		data: { data: { ...FOUNDATION_DATA } },
	},
	{
		path: 'degrees',
		component: CourseDegreeHubComponent,
		data: { data: { ...DEGREES_DATA } },
	},
	{
		path: 'clearing',
		component: CourseDegreeHubComponent,
		data: { data: { ...CLEARING_DATA } },
	},
	// END HUB ROUTES
	{
		path: '',
		children: [
			{
				path: 'degrees',
				children: [
					{
						path: ':subject',
						component: CourseSearchComponent,
						canActivate: [validateSubjectGuard],
					},
					{
						path: ':subject/:location',
						component: CourseSearchComponent,
						canMatch: [validateLocationGuard],
						canActivate: [validateSubjectGuard],
					},
					{
						path: ':degree/:subject',
						component: CourseSearchComponent,
						canMatch: [validateDegreeGuard],
						canActivate: [validateSubjectGuard],
					},
					{
						path: ':degree/:subject/:location',
						component: CourseSearchComponent,
						canMatch: [validateDegreeAndLocationGuard],
						canActivate: [validateSubjectGuard],
					},
				],
			},
			{
				path: 'search',
				children: [
					{ path: ':degree', component: CourseSearchComponent },
					{
						path: ':degree/:location',
						component: CourseSearchComponent,
					},
				],
			},
			{
				path: 'clearing/:subject',
				component: ClearingCourseSearchComponent,
			},
		],
		canActivate: [initialiseScrollerGuard],
		canDeactivate: [resetScrollerGuard],
	},
	{
		path: ':studyLevel',
		component: UniversityCourseSearchComponent,
		canActivate: [initialiseScrollerGuard, validateUniSlugGuard],
		canDeactivate: [resetScrollerGuard],
	},
];
